import React from "react";
import PropTypes from "prop-types";

export default function Tag({ label, ...props }) {
  if (!label) return null;
  return (
    <div className="Tag" {...props}>
      {label}
    </div>
  );
}

Tag.propTypes = {
  label: PropTypes.string,
};
